<div class="flex">
  <app-jkdatefield labelMode="floating" label="日期" [(value)]="date" [showClearButton]="true"
  (valueChange)="onValueChange($event)">
</app-jkdatefield>
<button mat-flat-button (click)="doQuery()">
    查詢
  </button>
  </div>
  <app-jkgridwin label="上市上櫃" [height]="200" ariaLabel=""
  (afterGridReady)="afterGridReady($event)">
  </app-jkgridwin>
